export const styles = ({ sizes }) => ({
  changed: {
    marginBottom: sizes.footerHeight + 50
  }
});
